"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Blog_1 = __importDefault(require("@kawaui/icons/build/icons/social/Blog"));
const Facebook_1 = __importDefault(require("@kawaui/icons/build/icons/social/Facebook"));
const Instagram_1 = __importDefault(require("@kawaui/icons/build/icons/social/Instagram"));
const Linkedin_1 = __importDefault(require("@kawaui/icons/build/icons/social/Linkedin"));
const Pinterest_1 = __importDefault(require("@kawaui/icons/build/icons/social/Pinterest"));
const Twitter_1 = __importDefault(require("@kawaui/icons/build/icons/social/Twitter"));
const Youtube_1 = __importDefault(require("@kawaui/icons/build/icons/social/Youtube"));
const PremiumPrivalia_1 = __importDefault(require("@kawaui/icons/build/icons/sponsorship/PremiumPrivalia"));
const react_1 = require("react");
const Styled = __importStar(require("./styles"));
exports.CommunityIcon = (0, react_1.memo)(function CommunityIcon({ name }) {
    switch (name.toLowerCase()) {
        case 'facebook':
            return (0, jsx_runtime_1.jsx)(Facebook_1.default, {});
        case 'youtube':
            return (0, jsx_runtime_1.jsx)(Youtube_1.default, {});
        case 'instagram':
            return (0, jsx_runtime_1.jsx)(Instagram_1.default, {});
        case 'pinterest':
            return (0, jsx_runtime_1.jsx)(Pinterest_1.default, {});
        case 'blog':
            return (0, jsx_runtime_1.jsx)(Blog_1.default, {});
        case 'twitter':
            return (0, jsx_runtime_1.jsx)(Twitter_1.default, {});
        case 'linkedin':
            return (0, jsx_runtime_1.jsx)(Linkedin_1.default, {});
        case 'ios':
            return (0, jsx_runtime_1.jsx)(Styled.IconApple, { width: "24px", height: "24px" });
        case 'android':
            return (0, jsx_runtime_1.jsx)(Styled.IconAndroid, { width: "24px", height: "24px" });
        case 'premium':
            return (0, jsx_runtime_1.jsx)(PremiumPrivalia_1.default, {});
        case 'huawei':
            return (0, jsx_runtime_1.jsx)(Styled.IconHuawei, { width: "24px", height: "24px" });
        default:
            return null;
    }
});
exports.default = exports.CommunityIcon;
